import Vue from 'vue';

export function priceFilter(val) {
    if (val) {
        return '￥' + parseFloat(val).toFixed(2);
    }
    return '￥0.00';
}

Vue.filter('priceFilter', priceFilter);
